/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Button, Col, FormGroup, FormLabel, Modal, Row } from 'react-bootstrap';
import { Form, Errors, Control, actions } from 'forms/rrf';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Viewer from 'react-viewer';
import ArrowButton from '../../../common/button-arrow';
import RequiredInput from '../../../common/form/elements/required-input';
import BsCheckbox from '../../../common/form/elements/bs-checkbox';
import Select from '../../../common/form/elements/select';
import DeclineSubmissionDialog from '../../submissions/decline-submission-dialog';
import TextInput from '../../../common/form/elements/text-input';
import {
  internalEnquirySubmission,
  repEnquirySubmission,
  itukEnquirySubmission,
  auditorValidateSubmission,
  auditorHoldSubmission,
  updateSubmissionFurtherValidationRequired
} from '../../../../actions/submissions';
import AuditAmount from './audit-amount';
import { weekOfSaleDate } from '../../../../utils/commonFunctions';

import './styles.css';

const declineCommentOptions = [
  {
    label: 'Store does not match evidence',
    value: 'STORE_MATCH_EVIDENCE',
    description: 'The evidence provided shows a different store to the one selected please resubmit with correct details'
  },
  {
    label: 'Wrong evidence type selected',
    value: 'WRONG_EVIDENCE_TYPE_SELECTED',
    description: 'The evidence type provided does not match the evidence type submitted' +
      ' Please resubmit your claim with the correct evidence type.'
  },
  {
    label: 'Wrong evidence type uploaded',
    value: 'WRONG_EVIDENCE_TYPE_UPLOADED',
    description: 'The evidence provided does not meet the requirements. Please resubmit your claim with EPOS evidence'
  },
  {
    label: 'Invalid Image',
    value: 'IMAGE_NOT_SHOW_THE_QTY',
    description: 'The image provided does not show the quantity that is being claimed for the product selected -' +
      ' please resubmit your claim with the supporting evidence or amended quantities'
  },
  {
    label: 'Duplicate submission',
    value: 'DUPLICATE_SUBMISSION',
    description: 'The image provided has already been used on a claim that has been or is being processed'
  },
  {
    label: 'Invalid Image - unreadable',
    value: 'IMAGE_BLURRY',
    description: 'The evidence provided is not a clear image, please retake and resubmit'
  },
  {
    label: 'Claim Missing Details',
    value: 'MISSING_DETAILS',
    description: 'Please ensure your claim has all the required details.'
  },
  {
    label: 'Packs Claimed Prior to Enrolment Date',
    value: 'CLAIMED_PRIOR_ENROLMENT_DATE',
    description: 'Unfortunately, the evidence uploaded has a date range that is before the enrolment date of the store.' +
      ' Please resubmit with correct evidence.'
  }
];

class AdminSubmissionForm extends Component {
  state = {
    outletCode: '',
    decline_confirm_dialog: false,
    postcodeplan_audit_amount_warning: false,
    postcodeplan_audit_amount_disable_validate: false,
    incentive_audit_amount_warning: false,
    disable_validate: false,
    disable_buttons: false,
    imageViewContainer: null
  };

  modalContainer = createRef();

  imageViewContainer = createRef();

  componentDidMount() {
    // react-viewer needs the real DOM node for its inline container, and that node is
    // rendered by this component — so it only exists once we're mounted. Resolving it
    // during render (e.g. document.getElementById) yields null on the first pass, which
    // makes the viewer portal itself into document.body as a full-screen overlay.
    this.setState({ imageViewContainer: this.imageViewContainer.current });
  }

  componentDidUpdate(prevProps) {
    const { formData, dispatch } = this.props;

    if (formData.postcodeplan_objective_id !== prevProps.formData.postcodeplan_objective_id) {
      dispatch(actions.resetValidity('deep.admin_submission.incentive_id'));
      dispatch(actions.resetValidity('deep.admin_submission.proof_type'));
    }
  }

  handleFileUpload = (file) => {
    const { dispatch } = this.props;

    dispatch(actions.push('deep.admin_submission.proof_of_purchases_attributes', {
      [Date.now()]: { persisted: false, proof_of_purchase: file }
    }));
  };

  handleFurtherValidationRequiredChange = (event) => {
    const { dispatch, id, model } = this.props;
    const payload = { further_validation_required: event.target.checked };

    dispatch(actions.submitFields(model, updateSubmissionFurtherValidationRequired(id, payload)));
  }

  resetPopup() {
    this.setState({ decline_confirm_dialog: false });
  }

  handleConfirmDecline(result) {
    const { onDecline } = this.props;

    this.setState({ disable_buttons: true });

    if (result) {
      onDecline();
    }

    this.resetPopup();
  }

  handleDeclineReasonSelectChange = (event) => {
    const { model, dispatch } = this.props;
    const declineReason = declineCommentOptions.find(declineComment => declineComment.value === event);

    dispatch(actions.change(
      `${model}.savi_comment`,
      declineReason ? `${declineReason.label} - ${declineReason.description}` : ''
    ));
  };

  handleInternalEnquiryClick = () => {
    if (this.state.disable_buttons) {
      return;
    }

    const {
      model, submissionId, formData, dispatch
    } = this.props;

    this.setState({ disable_buttons: true }, () => {
      dispatch(actions.submitFields(model, internalEnquirySubmission(submissionId, formData)));
    });
  };

  handleRepEnquiryClick = () => {
    if (this.state.disable_buttons) {
      return;
    }

    const {
      model, submissionId, formData, dispatch
    } = this.props;

    this.setState({ disable_buttons: true }, () => {
      dispatch(actions.submitFields(model, repEnquirySubmission(submissionId, formData)));
    });
  };

  handleITUKEnquiryClick = () => {
    if (this.state.disable_buttons) {
      return;
    }

    const {
      model, submissionId, formData, dispatch
    } = this.props;

    this.setState({ disable_buttons: true }, () => {
      dispatch(actions.submitFields(model, itukEnquirySubmission(submissionId, formData)));
    });
  };

  handleValidateClick = () => {
    if (this.state.disable_buttons) {
      return;
    }

    const {
      model, submissionId, formData, dispatch
    } = this.props;

    this.setState({ disable_buttons: true }, () => {
      dispatch(actions.submitFields(model, auditorValidateSubmission(submissionId, formData)));
    });
  };

  handleHoldClick = () => {
    if (this.state.disable_buttons) {
      return;
    }

    const {
      model, submissionId, formData, dispatch
    } = this.props;

    this.setState({ disable_buttons: true }, () => {
      dispatch(actions.submitFields(model, auditorHoldSubmission(submissionId, formData)));
    });
  };

  incentiveAuditAmount = () => {
    const { target, formData } = this.props;

    if (!!target && target < formData.audit_amount) {
      this.setState({ incentive_audit_amount_warning: true });
    }
  };

  postcodeplanAuditAmounts = () => {
    const sum = this.props.formData.audit_amounts.map(audit_amount => Number(audit_amount.value)).reduce((a, b) => a + b);

    if (sum > 4999 && sum < 10000) {
      this.setState({ postcodeplan_audit_amount_warning: true });
    }

    if (sum >= 10000) {
      this.setState({ postcodeplan_audit_amount_disable_validate: true, disable_validate: true });
    } else {
      this.setState({ disable_validate: false });
    }
  };

  closePopup = () => {
    this.setState({
      postcodeplan_audit_amount_warning: false,
      postcodeplan_audit_amount_disable_validate: false,
      incentive_audit_amount_warning: false
    });
  };

  haveAuditAmounts = () => {
    const {
      incentive_id, audit_amount, postcodeplan_objective_id, audit_amounts
    } = this.props.formData;

    if (!!incentive_id && !!audit_amount) {
      return true;
    }

    if (!!postcodeplan_objective_id && audit_amounts) {
      const values = audit_amounts.map(amount => amount.value);

      return (values.indexOf(null) === -1 && values.indexOf('') === -1);
    }

    return false;
  }

  handleAdminSubmit = (status) => {
    const { onSubmit, dispatch, formData } = this.props;
    const payload = { ...formData, status };

    dispatch(actions.change('deep.admin_submission.status', status));
    onSubmit(payload);
  }

  openImageViewer = (file) => {
    const params = new URLSearchParams({
      link: file.href,
      name: file.name || ''
    });

    window.open(`/image-viewer?${params.toString()}`, '_blank');
  };

  render() {
    const {
      formData, formValid, id, model, onValidate,
      onDecline, meta, editable, isAuditRoute,
      isTeamRoute, isAdminRoute, submissionStatus
    } = this.props;
    const {
      postcodeplan_audit_amount_warning,
      postcodeplan_audit_amount_disable_validate,
      incentive_audit_amount_warning,
      disable_validate,
      disable_buttons,
      imageViewContainer
    } = this.state;
    const {
      type, incentive_id, postcodeplan_objective_id, audit_completed,
      number_of_packs_solds, audit_amounts,
      outlet_wse_band, last_claim_validated_date, last_claim_validated_id,
      week_of_sale: weekOfSale
    } = formData;
    const hasIncentiveId = !!incentive_id;
    const hasPostcodeplanObjectiveId = !!postcodeplan_objective_id;
    const isPreValidatedStatus = submissionStatus === 'PRE-VALIDATED';
    const isPipValidateDisabled = !isPreValidatedStatus && isTeamRoute;
    const isDeclined = submissionStatus === 'DECLINED';
    const isValidated = submissionStatus === 'VALIDATED';
    const packsSoldIsDisabled = (hasPostcodeplanObjectiveId &&
       (!submissionStatus ||
         ['PENDING', 'APPROVED', 'DECLINED', 'VALIDATED', 'PRE-VALIDATED', 'QUERIED', 'INQUIRED'].includes(submissionStatus))
    );
    const packSoldsZeroAllowed = number_of_packs_solds ? number_of_packs_solds.length > 1 : false;
    const popup =
      postcodeplan_audit_amount_warning ||
      postcodeplan_audit_amount_disable_validate ||
      incentive_audit_amount_warning;
    let fileList = Object.assign({}, ...formData.proof_of_purchases_attributes);
    // Only files that are actually viewable: react-viewer reads `.src` off the active
    // image unconditionally, so a removed file or a not-yet-uploaded one (no href) would
    // otherwise put an entry with an undefined src into the carousel.
    const imageList = Object.values(fileList)
      .filter(original => original && original._destroy !== true && original.href)
      .map(original => ({
        src: original.href,
        alt: original.name
      }));
    const path = isAuditRoute ? 'audit/submissions/' : 'submissions/';

    fileList = Object.entries(fileList)
      .filter(([index, file]) => file && file._destroy !== true)
      .map(([index, file]) => {
        const link = file.href ? <div className="image-link" onClick={() => { this.openImageViewer(file); }}>{file.name}</div> : file.name;
        const possible_duplicates = file['possible-duplicates'] &&
          file['possible-duplicates'].map((possible_duplicate, num) => (
            <span key={possible_duplicate}>
              {num === 0 && <span>&nbsp;Possible duplicate(s):</span>}
              &nbsp;<Link target="_blank" to={`/${isTeamRoute ? 'team' : 'admin'}/${path}${possible_duplicate}`}>{possible_duplicate}</Link>
            </span>
          ));

        return (
          <div key={file.id || file.lastModified} style={{ paddingBottom: '5px' }}>
            {file.persisted === false ? file.proof_of_purchase.name : link }
            {possible_duplicates && possible_duplicates}
          </div>
        );
      });

    return (
      <div className='mg-bottom-60 mg-top-10' ref={this.modalContainer}>
        <div className='container-fluid'>
          {/* `row` is load-bearing: these two columns are direct children of the <form>,
              and Bootstrap 5 lays .col-* out with flex (a .row parent) where Bootstrap 3
              floated them. Without it the form stacks underneath the viewer. */}
          <Form model={model} className="row">
            <Col lg={5}>
              <Row id={'image-view-row'}>
                <h4>Proof of purchase</h4>
                <div className="file-list">{fileList}</div>
                <div id={'image-view-container'} ref={this.imageViewContainer}>
                  {imageViewContainer && imageList.length > 0 && (
                    <Viewer
                      visible
                      onClose={() => { this.setState({ visible: false }); } }
                      images={imageList}
                      container={imageViewContainer}
                      noClose
                      scalable={false}
                      downloadable={false}
                      noImgDetails
                      zoomSpeed={0.1}
                    />
                  )}
                  {imageList.length === 0 && (
                    <div className="no-images">No images to display</div>
                  )}
                </div>
              </Row>
            </Col>
            <Col lg={7}>
              <fieldset disabled={!editable}>
                <Row>
                  <Col md={6}>
                    <span className="text-bold">Status: </span>
                    {type === 'NGP' && submissionStatus === 'APPROVED' ? 'VALIDATED' : submissionStatus || 'PENDING'}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <span className="text-bold">Type: </span>
                    {type}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <span className="text-bold">Tier Band: </span>
                    {outlet_wse_band}
                  </Col>
                </Row>
                {last_claim_validated_date && (
                  <Row>
                    <Col md={6}>
                      <span className="text-bold">Last claim validated date: </span>
                      <Link to={`/${isTeamRoute ? 'team' : 'admin'}/${path}${last_claim_validated_id}`} target='_blank'>
                        {moment(last_claim_validated_date).format('YYYY-MM-DD')}
                      </Link>
                    </Col>
                  </Row>
                )}
                <br />
                <Col lg={6}>
                  <Row>
                    <Col md={12}>
                      <RequiredInput
                        label='Outlet name'
                        model='.outlet_name'
                        disabled
                      />
                    </Col>
                  </Row>
                  {hasIncentiveId && (
                    <Row>
                      <Col md={12}>
                        <Select
                          label='Incentive Name'
                          model='.incentive_id'
                          values={meta.incentives}
                          disabled
                          required={!hasPostcodeplanObjectiveId}
                        />
                      </Col>
                    </Row>
                  )}
                  {hasPostcodeplanObjectiveId && (
                    <Row>
                      <Col md={12}>
                        <Select
                          label='Postcodeplan Objective'
                          model='.postcodeplan_objective_id'
                          values={meta.postcodeplan_objectives}
                          disabled
                        />
                      </Col>
                    </Row>
                  )}
                </Col>
                <Col lg={6}>
                  <Row>
                    <Col md={6}>
                      <RequiredInput
                        label='User Type'
                        model='.user_group_name'
                        disabled
                      />
                    </Col>
                    <Col md={6}>
                      <RequiredInput
                        label='Proof type'
                        model='.proof_type'
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <RequiredInput
                        label='Submission ID'
                        value={id}
                        model='.id'
                        disabled
                      />
                    </Col>
                    <Col md={6}>
                      <RequiredInput
                        label='Outlet code'
                        model='.outlet_code'
                        value={formData.outlet_code}
                        disabled
                      />
                    </Col>
                  </Row>
                </Col>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <FormLabel>
                        Rep comment
                      </FormLabel>
                      <Control.textarea
                        className="form-control savi-audit-text-area"
                        model=".rep_comment"
                        disabled
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <TextInput
                      label="Start date"
                      model=".start_date"
                      disabled
                    />
                  </Col>
                  <Col md={6}>
                    <TextInput
                      label="End date"
                      model=".end_date"
                      disabled
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    {hasIncentiveId && (
                      <RequiredInput
                        label='Number of outers purchased'
                        model='.number_of_outers'
                        disabled={(submissionStatus === 'DECLINED' && !isAuditRoute) || !hasPostcodeplanObjectiveId}
                      />
                    )}
                    {hasPostcodeplanObjectiveId && number_of_packs_solds && (
                      <div>
                        <Row>
                          <Col md={7}>
                            Number of packs sold
                          </Col>
                          <Col md={2}>
                            Shelf price
                          </Col>
                        </Row>
                        {number_of_packs_solds.map((numberOfPacksSold, index) => (
                          <Row key={index}>
                            <Col md={2} style={{ marginTop: 10 }}>
                              {numberOfPacksSold.label}
                            </Col>
                            <Col md={5}>
                              <TextInput
                                model={`.number_of_packs_solds.${index}.value`}
                                disabled={packsSoldIsDisabled}
                                zeroAllowed={packSoldsZeroAllowed}
                              />
                            </Col>
                            <Col md={5}>
                              <TextInput
                                model={`.number_of_packs_solds.${index}.shelf-price`}
                                disabled
                              />
                            </Col>
                          </Row>
                        ))}
                      </div>
                    )}
                  </Col>
                </Row>
                {hasPostcodeplanObjectiveId && weekOfSale && (
                  <div>
                    <br />
                    <Row>
                      <Col md={12}>
                        Week of Sale: {weekOfSaleDate(weekOfSale)}
                      </Col>
                    </Row>
                    <br />
                  </div>
                )}
                <AuditAmount
                  onBlur={hasIncentiveId ? this.incentiveAuditAmount.bind(this) : this.postcodeplanAuditAmounts.bind(this)}
                  isAuditCompleted={audit_completed}
                  hasIncentiveId={hasIncentiveId}
                  hasPostcodeplanObjectiveId={hasPostcodeplanObjectiveId}
                  status={submissionStatus}
                  auditAmounts={audit_amounts}
                  isAudit
                />
                {!isAuditRoute && (
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <FormLabel>
                          Submission notes
                        </FormLabel>
                        <Control.textarea
                          className='form-control'
                          label='Submission notes'
                          model='.notes'
                          disabled={isValidated}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                {isAdminRoute && hasPostcodeplanObjectiveId && (
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <Control.checkbox
                          model="deep.admin_submission.further_validation_required"
                          component={BsCheckbox}
                          onChange={this.handleFurtherValidationRequiredChange}
                          disabled={isValidated}
                        >
                          Referred for further validation
                        </Control.checkbox>
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                {!isAuditRoute && hasPostcodeplanObjectiveId && (
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <FormLabel>
                          Validation Notes
                        </FormLabel>
                        <Control.textarea
                          className='form-control'
                          label='Validation Notes'
                          model='.validation_notes'
                          disabled={isValidated || !isPreValidatedStatus}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                {isAuditRoute && !isDeclined && (
                  <Row>
                    <Col md={12}>
                      <Select
                        label="Decline reason"
                        model="deep.admin_submission.decline_reason"
                        values={declineCommentOptions}
                        onChange={this.handleDeclineReasonSelectChange}
                        emptyValueDisabled={false}
                      />
                    </Col>
                  </Row>
                )}
                {(type === 'NGP' || type === 'Price IT +') && (
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <FormLabel>
                          {isAuditRoute ? 'Comments / Decline Reason' : 'Savi Submission Notes'}
                        </FormLabel>
                        <Control.textarea
                          className="form-control savi-audit-text-area"
                          model="deep.admin_submission.savi_comment"
                          disabled={!isAuditRoute}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                {isAuditRoute && (
                  <Row className="flex-row submission-actions">
                    <Col className="audit-button">
                      <ArrowButton
                        arrow={false}
                        submit={false}
                        onClick={() => this.setState({ decline_confirm_dialog: true })}
                        disabled={(!formData.savi_comment && submissionStatus !== 'INQUIRED') || disable_buttons}
                      >
                        Decline
                      </ArrowButton>
                    </Col>
                    <Col className="audit-button">
                      <ArrowButton
                        arrow={false}
                        submit={false}
                        onClick={this.handleInternalEnquiryClick}
                        disabled={disable_buttons}
                      >
                        Internal Enquiry
                      </ArrowButton>
                    </Col>
                    {type === 'Price IT +' && (
                      <Col className="audit-button">
                        <ArrowButton
                          arrow={false}
                          submit={false}
                          onClick={this.handleRepEnquiryClick}
                          disabled={disable_buttons}
                        >
                          REP Enquiry
                        </ArrowButton>
                      </Col>
                    )}
                    <Col className="audit-button">
                      <ArrowButton
                        arrow={false}
                        submit={false}
                        onClick={this.handleITUKEnquiryClick}
                        disabled={disable_buttons}
                      >
                        ITUK Enquiry
                      </ArrowButton>
                    </Col>
                    {submissionStatus === 'PENDING' && (
                      <Col className="audit-button">
                        <ArrowButton
                          arrow={false}
                          submit={false}
                          onClick={this.handleHoldClick}
                          disabled={disable_buttons}
                        >
                          Hold
                        </ArrowButton>
                      </Col>
                    )}
                    <Col className="audit-button">
                      <ArrowButton
                        arrow={false}
                        submit={false}
                        onClick={this.handleValidateClick}
                        disabled={disable_validate || !this.haveAuditAmounts() || disable_buttons}
                      >
                        Validate
                      </ArrowButton>
                    </Col>
                  </Row>
                )}
                {!isAuditRoute && hasPostcodeplanObjectiveId && !isValidated && (
                  <Col className="ta-left submission-actions" md={6}>
                    <Button
                      className="red-ghost-btn"
                      onClick={onValidate}
                      disabled={
                        isPipValidateDisabled ||
                        !this.haveAuditAmounts() ||
                        disable_buttons ||
                        (isPreValidatedStatus && !formData.validation_notes)
                      }
                    >
                      Validate
                    </Button>
                    <Button
                      className="red-ghost-btn"
                      onClick={onDecline}
                      disabled={!formData.notes || isPipValidateDisabled || disable_buttons || isDeclined}
                    >
                      Decline
                    </Button>
                  </Col>
                )}
                {!isAuditRoute && !hasPostcodeplanObjectiveId && (
                  <Col className="ta-left submission-actions" md={6}>
                    <Button
                      className="red-ghost-btn"
                      onClick={() => this.handleAdminSubmit('VALIDATED')}
                      disabled={isPipValidateDisabled || !this.haveAuditAmounts() || disable_buttons || isValidated}
                    >
                      Validate
                    </Button>
                    <Button
                      className="red-ghost-btn"
                      onClick={() => this.handleAdminSubmit('DECLINED')}
                      disabled={disable_buttons || !formData.notes}
                    >
                      Decline
                    </Button>
                  </Col>
                )}
              </fieldset>
              {hasPostcodeplanObjectiveId && isValidated && isAdminRoute && (
                <div>
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <FormLabel>
                          Decline Reason*
                        </FormLabel>
                        <Control.textarea
                          className="form-control savi-audit-text-area"
                          model="deep.admin_submission.decline_reason"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button
                    className="red-ghost-btn submission-actions"
                    onClick={() => this.setState({
                      decline_confirm_dialog: true,
                      decline_custom_message: 'Are you sure you want to decline this validated submission? ' +
                        'This will result in a negative point transaction!'
                    })}
                    disabled={ disable_buttons || isDeclined || !formData.decline_reason }
                  >
                    Decline
                  </Button>
                </div>
              )}
            </Col>
          </Form>
        </div>
        {this.state.decline_confirm_dialog && (
          <DeclineSubmissionDialog
            decline_custom_message={this.state.decline_custom_message}
            onClose={this.handleConfirmDecline.bind(this)}
          />
)}
        {popup && isAuditRoute && (
          <Modal
            container={this.modalContainer.current}
            show
          >
            <Modal.Body>
              {postcodeplan_audit_amount_warning && (
              <div>
                Are you sure this is the correct value? This is a high value submission.
                <br /><br />
                If you are sure then please <b>VALIDATE</b>, if not then please press the <b>INTERNAL ENQUIRY</b> button
              </div>
              )}
              {postcodeplan_audit_amount_disable_validate && (
              <div>
                This submission is over the maximum value that can be awarded.
                <br /><br />
                Please press the <b>INTERNAL ENQUIRY</b> button
              </div>
              )}
              {incentive_audit_amount_warning && (
              <div>
                Are you sure this is the correct value? This is over the maximum allowance for this incentive.
                <br /><br />
                If you are sure then please <b>VALIDATE</b>, if not then please press the <b>INTERNAL ENQUIRY</b> button
              </div>
              )}
              <br/>
              <Button className="grey-ghost-btn" onClick={this.closePopup.bind(this)}>
                CLOSE
              </Button>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.admin_submission,
  formValid: state.deep.forms.admin_submission.$form.valid
});

export default connect(mapStateToProps)(AdminSubmissionForm);
